/**
 * Une mise à jour silencieuse est entièrement pilotée par l'APK : la page n'affiche
 * rien au commerçant et ne lance ni téléchargement ni redémarrage.
 */
export function shouldStartWebUpdate(
  manifest: { forceUpdate: boolean; silent?: boolean },
  alreadyDismissed: boolean,
  shownThisSession: boolean,
): boolean {
  if (manifest.silent || shownThisSession) return false;
  return manifest.forceUpdate || !alreadyDismissed;
}
